import { USA_APPLET_SIM, USA_APPLET_ZEBRA } from "./Constantes";

export const gerarId = () =>
  "_" +
  Math.random()
    .toString(36)
    .substr(2, 9);

export const convertePrimeiraLetraNomeMaiusculo = string => {
  const splitStr = string.toLowerCase().split(" ");
  for (let i = 0; i < splitStr.length; i++) {
    if (splitStr[i].length > 2) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
  }
  return splitStr.join(" ");
};

export const concatenarInformacoesSolicitante = (solicitante, nomeMaiusculo) => {
  return `${nomeMaiusculo ? solicitante.nome : convertePrimeiraLetraNomeMaiusculo(solicitante.nome)} - ${solicitante.siglaConselho} ${solicitante.numeroConselho} / ${solicitante.ufConselho}`;
};

export const verificaTelefoneFixo = telefone => {
  var re = /^\([1-9]{2}\) [0-9]{4}-[0-9]{4}$/;
  return re.test(telefone);
};

export const verificaTelefoneFixoSemFormatacao = telefone => {
  if (telefone) telefone = telefone.replace(/[^0-9]+/g, "");
  var re = /^[1-9]{2}[0-9]{4}[0-9]{4}$/;
  return re.test(telefone);
};

export const verificaCelular = celular => {
  var re = /^\([1-9]{2}\) 9[0-9]{4}-[0-9]{4}$/;
  return re.test(celular);
};

export const verificaCelularSemFormatacao = celular => {
  if (celular) celular = celular.replace(/[^0-9]+/g, "");
  var re = /^[1-9]{2}9[0-9]{4}[0-9]{4}$/;
  return re.test(celular);
};

export const verificaEmail = email => {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const removeAcentoMaiusculo = (text) => {       
    let palavra = text.toUpperCase()
                      .replace(/^[^A-Z0-9]+/gi,"")                                     
                      .replace(new RegExp('[ÁÀÂÃ]','gi'), 'A')
                      .replace(new RegExp('[ÉÈÊ]','gi'), 'E')
                      .replace(new RegExp('[ÍÌÎ]','gi'), 'I')
                      .replace(new RegExp('[ÓÒÔÕ]','gi'), 'O')
                      .replace(new RegExp('[ÚÙÛ]','gi'), 'U')
                      .replace(new RegExp('[Ç]','gi'), 'C');
    return palavra;                 
};

export const verificarApplet = (usaApplet) => {
  switch (usaApplet) {
    case "S":
      return USA_APPLET_SIM;
    case "Z":
      return USA_APPLET_ZEBRA;
    default:
      return false;
  }
}